import React, { Fragment } from 'react';
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box
} from '@mui/material';
import { MessageBubble } from 'pages/Campaigns/components/MessageBubble';
import { Conversation } from 'services/conversations/types';
import { openingMessagesTableSx } from 'pages/Campaigns/subpages/styles';

type Props = {
  conversations: Conversation[] | undefined;
};

export const OpeningMessagesTable: React.FC<Props> = ({ conversations }) => {
  return (
    <TableContainer>
      <Table>
        <TableHead sx={openingMessagesTableSx.tableHeader}>
          <TableRow>
            <TableCell>First name</TableCell>
            <TableCell>Last name</TableCell>
            <TableCell>Phone</TableCell>
            <TableCell>Email</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {conversations?.map((conversation) => {
            const messageContent = conversation.messages?.items?.[0]?.body;

            return (
              <Fragment key={conversation.id}>
                <TableRow>
                  <TableCell>{conversation.participantFirstName}</TableCell>
                  <TableCell>{conversation.participantLastName}</TableCell>
                  <TableCell>{conversation.participantPhoneNumber}</TableCell>
                  <TableCell>{conversation.participantEmailAddress}</TableCell>
                </TableRow>
                {messageContent && (
                  <TableRow>
                    <TableCell colSpan={4}>
                      <Box sx={openingMessagesTableSx.messageBubbleContainer}>
                        <MessageBubble text={messageContent} />
                      </Box>
                    </TableCell>
                  </TableRow>
                )}
              </Fragment>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
